
export class CollectionKeyHelper {

  public static HomeReviews = "home-reviews";
  public static HomeItineraries = "home-itineraries";
  public static HomeArticles = "home-blog";

  public static LocationOverviewSections = (...ids: number[]) => `location-${ids.join("-")}-overview`;
  public static LocationItineraries = (...ids: number[]) => `location-${ids.join("-")}-itineraries`;
  public static LocationItinerariesGroupTours = (...ids: number[]) => `location-${ids.join("-")}-itineraries-group-tours`;
  public static LocationItinerariesTailoredTours = (...ids: number[]) => `location-${ids.join("-")}-itineraries-tailored-tours`;
  public static LocationReviews = (...ids: number[]) => `location-${ids.join("-")}-reviews`;
  public static LocationRelated = (...ids: number[]) => `location-${ids.join("-")}-related`;
  public static LocationReviewsRelated = (id: number) => `location-${id}-reviews-related`;

  public static LtoItineraries = (ltoId: number) => `lto-${ltoId}-itineraries`;
  public static LtoReviews = (ltoId: number) => `lto-${ltoId}-reviews`;
  public static LtoOverviewRelated = (ltoId: number) => `lto-${ltoId}-overview-related`;

  public static Inspiration = "inspiration";

  public static ContentDetailRelated = (id: number) => `content-${id}-related`;

  public static DropDownContentReviews = "dropdown-content-reviews";
  public static DropDownContentItineraries = "dropdown-content-itineraries";
  public static DropDownContentArticles = "dropdown-content-articles";

}
